// // import React from 'react';
// // import Image from '../../../components/AppImage';

// // import { Swiper, SwiperSlide } from 'swiper/react';
// // import 'swiper/css';

// // const OffersSection = () => {
// //   const offers = [
// //     { id: 1, image: "/assets/images/offer.jpg" },
// //     { id: 2, image: "/assets/images/offer.jpg" },
// //     { id: 3, image: "/assets/images/offer.jpg" },
// //     { id: 4, image: "/assets/images/offer.jpg" },
// //     { id: 5, image: "/assets/images/offer.jpg" },
// //     { id: 6, image: "/assets/images/offer.jpg" },
// //     { id: 7, image: "/assets/images/offer.jpg" }
// //   ];

// //   return (
// //     <section
// //       id="offers"
// //       className="w-full px-4 md:px-6 lg:px-8 py-2 md:py-4 lg:py-6 scroll-mt-32"
// //     >
// //       <div className="max-w-7xl mx-auto">
// //         <h2 className="text-lg md:text-xl lg:text-2xl font-bold text-foreground mb-4 md:mb-6 font-[cairo]">
// //           عروض
// //         </h2>

// //         <Swiper
// //           spaceBetween={16}
// //           slidesPerView={3}
// //           breakpoints={{
// //             768: {
// //               slidesPerView: 4,
// //               spaceBetween: 20,
// //             },
// //             1024: {
// //               slidesPerView: 5,
// //               spaceBetween: 24,
// //             },
// //           }}
// //           dir="rtl"
// //         >
// //           {offers.map((offer) => (
// //             <SwiperSlide key={offer.id}>
// //               <div className="relative w-full h-38 md:h-46 lg:h-54 rounded-[8px] overflow-hidden">
// //                 <Image
// //                   src={offer.image}
// //                   className="w-full h-full object-cover"
// //                 />
// //               </div>
// //             </SwiperSlide>
// //           ))}
// //         </Swiper>

// //       </div>
// //     </section>
// //   );
// // };

// // export default OffersSection;
// import React, { useEffect, useState } from 'react';
// import Image from '../../../components/AppImage';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/css';
// import { useNavigate } from 'react-router-dom';
// import { base_url } from 'Backend/api';

// const OffersSection = () => {
//   const [offers, setOffers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchOffers = async () => {
//       setLoading(true);
//       try {
//         const response = await fetch(`${base_url}/api/restaurant/offers`);
//         const data = await response.json();
//         if (data.status) {
//           setOffers(data.data || []);
//         } else {
//           setOffers([]);
//         }
//       } catch (error) {
//         console.error("خطأ في جلب العروض:", error);
//         setOffers([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchOffers();
//   }, []);

//   if (loading) {
//     return (
//       <div className="flex justify-center py-10">
//         <div className="w-14 h-14 border-4 border-red-500 border-t-transparent rounded-full animate-spin"></div>
//       </div>
//     );
//   }

//   if (!offers.length) return null; 

//   return (
//     <section
//       id="offers"
//       className="w-full px-4 md:px-6 lg:px-8 py-1 md:py-4 lg:py-6 scroll-mt-32"
//     >
//       <div className="max-w-7xl mx-auto">
//         <h2 className="text-[14px] md:text-[16px] lg:text-[18px] font-bold text-foreground mb-2 md:mb-6 font-[cairo]">
//           عروض
//         </h2>

//         <Swiper
//           spaceBetween={10}
//           slidesPerView={3.4}
//           breakpoints={{
//             768: {
//               slidesPerView: 4,
//               spaceBetween: 20,
//             },
//             1024: {
//               slidesPerView:8,
//               spaceBetween: 10,
//             },
//           }}
//           dir="rtl"
//         >
//           {offers.map((offer) => (
//             <SwiperSlide key={offer.id}>
//               <div
//                 className="relative w-full h-38 md:h-46 lg:h-54 rounded-[4px] overflow-hidden cursor-pointer group"
//                 onClick={() => navigate(`/restaurant/${offer.restaurant.slug}`)}
//               >
//                 <Image
//                   src={offer.image}
//                   className="w-[100px] h-[100px] object-cover transition-transform duration-500 ease-in-out group-hover:scale-110"
//                   alt={offer.title}
//                 />
               
//               </div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </div>
//     </section>
//   );
// };

// export default OffersSection;
import React, { useEffect, useState } from 'react';
import Image from '../../../components/AppImage';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { useNavigate } from 'react-router-dom';
import { base_url } from 'Backend/api';
import AppSpinner from 'components/ui/AppSpinner';

const OffersSection = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOffers = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${base_url}/api/restaurant/offers`);
        const data = await response.json();
        if (data.status) {
          setOffers(data.data || []);
        } else {
          setOffers([]);
        }
      } catch (error) {
        console.error("خطأ في جلب العروض:", error);
        setOffers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchOffers();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center py-10">
        <AppSpinner />
      </div>
    );
  }

  if (!offers.length) return null;

  return (
    <section
      id="offers"
      className="w-full px-4 md:px-6 lg:px-8 py-1 md:py-4 lg:py-6 scroll-mt-32"
    >
      <div className="max-w-7xl mx-auto">
        <h2 className="text-[14px] md:text-[16px] lg:text-[18px] font-bold text-foreground mb-2  font-[cairo]">
          عروض
        </h2>

        <Swiper
          spaceBetween={10}
          slidesPerView={3.5} // 👈 موبايل
          breakpoints={{
            480: {
              slidesPerView: 3.5,
            },
            640: {
              slidesPerView: 3,
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 12,
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 16,
            },
            1280: {
              slidesPerView: 6,
              spaceBetween: 20,
            },
          }}
          dir="rtl"
        >
          {offers.map((offer) => (
            <SwiperSlide key={offer.id}>
              <div
                className="
                  relative w-full 
                  h-[110px] sm:h-[130px] md:h-[150px] lg:h-[170px]
                  rounded-[6px] overflow-hidden 
                  cursor-pointer group
                "
                onClick={() => navigate(`/restaurant/${offer.restaurant.slug}`)}
              >
                <Image
                  src={offer.image}
                  alt={offer.title}
                  className="
                    w-full h-full object-cover
                    transition-transform duration-500
                    group-hover:scale-110
                  "
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default OffersSection;